import React, { useContext } from 'react'
import { AuthContext } from '../pages/auth/AuthContext';
import { useSelector } from 'react-redux';

const Loader = () => {
  const { isLoading } = useContext(AuthContext);
  const openSlideBar = useSelector((store) => store.root.openSlideBar);
  return (
    <div
      className={openSlideBar || isLoading ? 'loader_container not-login' : 'loader_container'}
      role="status"
      aria-live="polite"
      aria-label="Loading"
    >
      <span className="sm-spinner" />
    </div>
  )
}

export default Loader
